import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import { AuthTokenService } from '../../../shared/services/auth-token.service';

import { SurveyService } from './../surveys.service';
import { CreateNewReportModel, QuestionFilterModel, ListAnswersModel, ListQuestionsModel, SaveReportModel } from './../../../models/survey/survey.model';
import { DataTransferService } from './../../../shared/services/data-transfer.service';
import { forEach } from '@angular/router/src/utils/collection';
import {PreviousUrlService} from "../../../shared/services/previous-url.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CustomValidators} from "ng2-validation";



@Component({
  selector: 'app-new-report',
  templateUrl: './new-report.component.html',
  styleUrls: ['./new-report.component.less']
})

export class NewReportComponent implements OnInit {
  dropdown = false;
  dropdownLabel = 'Select';
  age = ['15-24', '25-34', '35-44', '45+'];
  gender = ['Male', 'Female'];
  location = ['London', 'Belgrade'];
  ageGroup = ['15-24', '25-34', '35-44'];
  genderGroup = ['Male', 'Female'];
  ageLabel =['Age'];
  genderLabel = ['Gender'];
  locationLabel = ['Location'];
  ageGroupLabel = ['What’s your age ?'];
  mainQuestionLabel = ['Choose a question'];
  surveyId: number;
  surveyTitle: string;
  showLoader = false;
  createReportModel: CreateNewReportModel;
  listQuestions = new Array<QuestionFilterModel>();
  newReportName: string;
  valForm: FormGroup;
  saveModel = new SaveReportModel();

  constructor(private router: Router, private route: ActivatedRoute, private fb: FormBuilder, private surveyService: SurveyService, private shareService: PreviousUrlService) {
    this.route.params.subscribe();
  }

  ngOnInit() {
    this.valForm = this.fb.group({
      'reportname': [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
    });
    this.showLoader = true;
    this.surveyId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.surveyTitle = this.route.snapshot.paramMap.get('title');
    this.shareService.setSurveyTitle(this.surveyTitle);
    this.surveyService.getReportCreateModel(this.surveyId).subscribe(
      (response) => {
        this.createReportModel = response;

        this.showLoader = false;
      },
      (error) => {
        this.showLoader = false;

      }
    );

  }

  selectQuestion(e, index) {
    this.listQuestions[index].id = e.id;
  }

  getSelectedAnswers(model: QuestionFilterModel) {
    if (model.id > 0) {
      return this.createReportModel.listQuestions.find(a => a.id == model.id).listAnswers;
    }
    else
      return [];
  }

  pushAnswer(i, aId) {
    // if empty array
    if (this.listQuestions[i].listAnswerId == undefined) {
      this.listQuestions[i].listAnswerId = new Array<number>();
      this.listQuestions[i].listAnswerId.push(aId);
      return;
    }

    // else if there is something, check it does not exist and add
    if (this.listQuestions[i].listAnswerId.find(a => a == aId) == undefined) {
      this.listQuestions[i].listAnswerId.push(aId);
    }
    else {
      this.listQuestions[i].listAnswerId.splice(this.listQuestions[i].listAnswerId.indexOf(aId), 1);
    }
  }

  addFilter() {
    this.listQuestions.push(new QuestionFilterModel());
  }

  removeFilter(index) {
    this.listQuestions.splice(index, 1);
  }

  setAge(a) {
    // ageGroup = ['15-24', '25-34', '35-44'];
    if (a == '15-24') {
      this.saveModel.ageFrom = 15;
      this.saveModel.ageTo = 24;
    }
    else if (a == '25-34') {
      this.saveModel.ageFrom = 25;
      this.saveModel.ageTo = 34;
    }
    else if (a == '35-44') {
      this.saveModel.ageFrom = 35;
      this.saveModel.ageTo = 44;
    }
    else if (a == '45+') {
      this.saveModel.ageFrom = 45;
      this.saveModel.ageTo = 200;
    }
    else {
      this.saveModel.ageFrom = null;
      this.saveModel.ageTo = null;
    }
  }

  setGender(g) {
    if (g == 'Male')
      this.saveModel.gender = 1;
    else if (g == 'Female')
      this.saveModel.gender = 2;
    else
      this.saveModel.gender = null;
  }

  setCountry(id) {
    this.saveModel.countryId = id;
  }

  toggleDropdown() {
    this.dropdown = !this.dropdown;
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.dropdown = false;
    }
  }

  saveReport(redirect) {
    for (const c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      this.saveModel.surveyId = this.surveyId;
      this.saveModel.listQuestion = this.listQuestions.filter(a => a.id > 0 && a.listAnswerId.length > 0);
      this.saveModel.name = this.newReportName;
      this.showLoader = true;
      this.surveyService.saveReport(this.saveModel).subscribe(
        (response) => {
          this.showLoader = false;
          if (redirect) {
            // show report
            this.router.navigate(['/surveys/analysis/' + this.surveyId + '/' + response + '/' + this.surveyTitle]);
          }
          else {
            // clean filter
            this.listQuestions = new Array<QuestionFilterModel>();
            this.listQuestions.push(new QuestionFilterModel());
            this.newReportName = null;
          }
        },
        (error) => {
          this.showLoader = false;
        }
      );
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-report/new-report.component.ts